export const DEFAULT_TOOLBAR = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  '|',
  'formatselect',
  '|',
  'unorderedlist',
  'orderedlist',
  '|',
  'alignleft',
  'aligncenter',
  'alignright',
  'alignjustify',
  '|',
  'emoji',
] as const;
